import React from "react"
import ReactTooltip from "react-tooltip"
import "./socialLinks.css";

const SocialLinks = (props) => {
  const { svgFiles, links } = props;

  return (
    <div className="social-links">
      {links.map((link, i) => {
        // fetches the image based on the value that that is set on the appropriate json element
        const iconForLink = svgFiles.edges.find(element => {
          return element.node.name === link.filename
        });

        if (iconForLink) {
          return (
            <React.Fragment key={i} >
              <a target="_blank" rel="noopener noreferrer" href={link.url} data-tip={link.tooltip}>
                <img src={iconForLink.node.publicURL} alt=""/>
              </a>
            </React.Fragment>
          )
        }

        return <React.Fragment key={i} />
      })}
      <ReactTooltip place="bottom" offset={{ bottom: 10 }} />
    </div>
  )
}
export default SocialLinks;
